module.exports = __webpack_public_path__ + "img/globeweb.78746177.png";